import { useEffect, useState } from "react";
import { Modal } from "../ui/modal";
import { Button } from "../ui/button";
import { Loader2 } from "lucide-react"; // Loader icon for loading state

interface AlertModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
  description?: string;
}

export const AlertModal: React.FC<AlertModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  loading,
}) => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return null;
  }
  const handleConfirm = () => {
    onConfirm();

    onClose();
  };

  return (
    <Modal
      title="Êtes-vous sûr ?"
      description="Cette action ne peut pas être annulée."
      isOpen={isOpen}
      onClose={onClose}
    >
      <div className="flex items-center justify-end w-full pt-6 space-x-2">
        <Button disabled={loading} variant="outline" onClick={onClose}>
          Annuler
        </Button>
        <Button
          disabled={loading}
          variant="destructive"
          onClick={handleConfirm}
        >
          {loading ? (
            <Loader2 className="mr-2 animate-spin" /> // Show loader if loading is true
          ) : (
            "Confirmer"
          )}
        </Button>
      </div>
    </Modal>
  );
};
